import { Button } from '@/components/ui/button'
import { CardHeader, CardTitle, Card, CardContent } from '@/components/ui/Card'
import useForgotPassword from '@/services/api/auth/useForgotPassword'
import React from 'react'

export default function ResetSuccess({ email, goBack, ...props }) {
  const { forgotPassword, forgotPasswordStatus } = useForgotPassword()

  function resend() {}

  return (
    <Card {...props}>
      <CardHeader>
        <CardTitle>Check your email</CardTitle>
      </CardHeader>

      <CardContent className="font-normal text-txt-primary">
        {forgotPasswordStatus.status === 'success' ? (
          <p>
            We've resent password reset instructions to{' '}
            <span className="font-semibold">{email}</span> if it is an email on
            file. Please check again. If you still haven't received an email,{' '}
            <Button
              variant="link"
              className="h-auto p-0 underline"
              onClick={goBack}
            >
              try a different email
            </Button>
            .
          </p>
        ) : (
          <p>
            Thanks! If <span className="font-semibold">{email}</span> matches an
            email we have on file, then we've sent you an email containing
            further instructions for resetting your password.
            <br />
            If you haven't received an email in 10 minutes, check your spam,{' '}
            <Button
              disabled={forgotPasswordStatus.status === 'pending'}
              type="button"
              onClick={() => forgotPassword({ email })}
              variant="link"
              className="h-auto p-0 underline"
            >
              resend
            </Button>
            , or try a{' '}
            <Button
              variant="link"
              className="h-auto p-0 underline"
              onClick={() => goBack()}
            >
              different email
            </Button>
            .
          </p>
        )}
      </CardContent>
    </Card>
  )
}
